/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { number } from 'prop-types';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { formatDigitLength } from '../../utilities/utils';

export interface HierarchicalArgs {
	label: string;
	count: number;
	reference: number;
}

/**
 * Renders simple count for the hierarchy based endpoints
 * @param data
 * @returns {JSX.Element}
 * @constructor
 */
export function HierarchicalCountRenderer(data: HierarchicalArgs): JSX.Element {
	if (!data) return <div />;

	const { label, count, reference } = data;

	return (
		<div cy-test="tooltip" css={hierachicalStyle}>
			<div cy-test="tooltip-label">{label}</div>
			<div cy-test="tooltip-count">{count}</div>
			{reference && (
				<div>
					<span>out of</span> <span>{reference}</span>
				</div>
			)}
		</div>
	);
}

export interface SubtitleArgs {
	title: string;
	count: number;
	subtitle: string;
}

/**
 * Renders simple count for things with title/subtitle
 * @param data
 * @returns {JSX.Element}
 * @constructor
 */
export function SubtitleCountRenderer(data: SubtitleArgs): JSX.Element {
	if (!data) return <div />;

	const { title, count, subtitle } = data;

	return (
		<div cy-test="subtitle-tooltip" css={subtitleStyle}>
			<div className={'title'} cy-test="subtitle-tooltip-title">
				{title}
			</div>
			<div className={'container'}>
				<div className={'subtitle'} cy-test="subtitle-tooltip-subtitle">
					{subtitle}
				</div>
				<div className={'count'} cy-test="subtitle-tooltip-count">
					{formatDigitLength(count, 3)}
				</div>
			</div>
		</div>
	);
}

const hierachicalStyle = css`
	display: flex;
	font-size: 1.25rem;

	div:first-of-type {
		margin-right: 8px;
		font-weight: lighter;
	}

	div:nth-of-type(2) {
		font-weight: normal;
		margin-right: 8px;
	}

	div:last-of-type {
		span:first-of-type {
			font-weight: lighter;
			margin-right: 4px;
		}
	}
`;

const subtitleStyle = css`
	display: flex;
	flex-direction: column;
	font-size: 1.25rem;
	pointer-events: none;

	.title {
		font-weight: lighter;
	}

	.container {
		font-size: 1rem;
		display: flex;

		.subtitle {
			font-weight: lighter;
			margin-right: 12px;
		}
	}
`;
